import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.nav.bottom');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { RU } from "src/libs/portal/korslovo/i18n";

@Component({
    selector: 'wiz-component-nav-bottom',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.nav.bottom/view.scss */
:host {
  display: block;
}`],
})
export class ComponentNavBottomComponent implements OnInit {
    public ru = RU;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
    }

    public isActive(link: string) {
        const path = location.pathname;
        if (link === '/category') {
            return path.indexOf('/category') === 0 || path.indexOf('/learn') === 0 || path.indexOf('/quiz') === 0;
        }
        return path.indexOf(link) === 0;
    }

    public navClass(link: string) {
        if (this.isActive(link)) {
            return 'flex flex-col items-center justify-center gap-0.5 text-emerald-600';
        }
        return 'flex flex-col items-center justify-center gap-0.5 text-gray-400';
    }
}

export default ComponentNavBottomComponent;